<app-data-table mainTitle="Modos de Prestação"
                singleTitle="Modo de Prestação"
                routerPath="/siscoserv/modo-prestacao"
                entityPath="/tbmodoprestacao"
                [entity]="tbModoPrestacao"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
